import i18n from '@/locales/init';

interface IPriceCard {
  label: string;
  price: number;
  dayPrice: number;
  isMain?: string;
  selected?: boolean;
  onSelected?: ()=> void;
  classNames?: string;
}
export const PriceCard = (props: IPriceCard)=>{
  const {label, price, dayPrice, isMain, selected, onSelected, classNames} = props;
  const border = selected ? 'border-[#2254F4]' : 'border-[#E5E5E5]';
  const textColor = selected ? 'text-[#2254F4]' : isMain ? 'text-[#E49A23]' : 'text-[#000000]';
  let mainBg1 = isMain ? 'bg-[#FDF5E8]' : 'bg-[#FFFFFF]';
  let mainBg2 = isMain ? 'bg-[#FFE6BD]' : 'bg-[#F7F7F7]';
  if (selected){
    mainBg1 = 'bg-[#F6FCFF]';
    mainBg2 = 'bg-[#DEF1FF]';
  }
  return <div className={`relative ${mainBg1} overflow-hidden cursor-pointer
    rounded-[16px] border ${border} text-center py-[34px] min-w-[117px] dyy_sm:min-w-[194px] ${classNames}` } onClick={onSelected}>
    <div className={`dyy_sm:text-[16px] font-medium ${textColor} text-[14px] whitespace-nowrap`}>{label}</div>
    <div className='pt-[10px]'>
      <span className='text-[#F54531] text-[12px] font-bold'>¥</span>
      <span className='text-[#F54531] text-[24px] font-bold mx-[2px]'>{price}</span>
      <span className='text-[12px] font-bold'>{i18n.t('元')}</span>
    </div>
    <div className={`absolute bottom-0 w-full left-0 h-[28px] leading-[28px] ${mainBg2} text-[12px] ${textColor}`}>{i18n.t('每天仅需{{v}}元', {v: dayPrice})}</div>
    {isMain && <div className='absolute right-0 top-0 bg-[#F5222D] text-white text-[12px] rounded-bl-[8px] px-[10px] py-[4px] font-semibold'>{isMain}</div>}
  </div>;
};
